/* eslint-disable */
export default {
  contactDetails: 'Yhteystiedon tiedot',
  loadingContact: 'Ladataan yhteystietoa...',
  contactNotFound: 'Yhteystietoa ei löytynyt.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
